function PurchaseUpload() {
  return null;
}

export default PurchaseUpload;
